import type { ComponentType } from 'react';
import type { KeyDocumentType } from '@trinity/chat';
import { ArchiveIcon } from './Archive';
import { AudioIcon } from './Audio';
import { DefaultIcon } from './Default';
import { DiscussionGuideIcon } from './DiscussionGuide';
import { Doc } from './Doc';
import { ImageIcon } from './Image';
import type { FileIconProps } from './interfaces';
import { PdfIcon } from './Pdf';
import { PresentationIcon } from './Presentation';
import { SpreadsheetIcon } from './Spreadsheet';
import { VideoIcon } from './Video';

export const ArchiveExtensions = new Set(['7z', 'gz', 'pkg', 'rar', 'tar', 'zip']);

export const DocExtensions = new Set(['doc', 'docm', 'docx', 'pages', 'txt', 'wpd', 'xml']);

export const SpreadsheetExtensions = new Set([
  'csv',
  'numbers',
  'ods',
  'wk3',
  'wks',
  'xlr',
  'xls',
  'xlsb',
  'xlsm',
  'xlsx',
]);

export const PdfExtensions = new Set(['pdf']);

export const PresentationExtensions = new Set(['key', 'odp', 'pps', 'ppsx', 'ppt', 'pptm', 'pptx']);

export const VideoExtensions = new Set([
  'avi',
  'flv',
  'h264',
  'm4v',
  'mkv',
  'mov',
  'mp4',
  'mpg',
  'mpeg',
  'webm',
  'wmv',
]);

export const AudioExtensions = new Set(['flac', 'm4a', 'm4b', 'mid', 'midi', 'mp2', 'mp3', 'wav']);

export const ImgExtensions = new Set(['ai', 'bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'svg']);

// A key document's icon follows its file_type, not its extension. Add an entry for each new type.
export const IconByFileType: Record<KeyDocumentType, ComponentType<FileIconProps>> = {
  discussion_guide: DiscussionGuideIcon,
};

export function getIconByExtension(extension: string): ComponentType<FileIconProps> {
  if (!extension) return DefaultIcon;

  const lowercaseExtension = extension.toLowerCase();
  if (ImgExtensions.has(lowercaseExtension)) {
    return ImageIcon;
  } else if (AudioExtensions.has(lowercaseExtension)) {
    return AudioIcon;
  } else if (VideoExtensions.has(lowercaseExtension)) {
    return VideoIcon;
  } else if (PdfExtensions.has(lowercaseExtension)) {
    return PdfIcon;
  } else if (SpreadsheetExtensions.has(lowercaseExtension)) {
    return SpreadsheetIcon;
  } else if (DocExtensions.has(lowercaseExtension)) {
    return Doc;
  } else if (PresentationExtensions.has(lowercaseExtension)) {
    return PresentationIcon;
  } else if (ArchiveExtensions.has(lowercaseExtension)) {
    return ArchiveIcon;
  } else {
    return DefaultIcon;
  }
}
